<script lang="js">
export default {
  name: "DatabaseMgt",
  computed: {
    canBackup() {
      return this.$store.getters.hasPermission("database", "backup");
    },
    canRestore() {
      return this.$store.getters.hasPermission("database", "restore");
    },
    canManage() {
      return this.$store.getters.hasPermission("database", "manage");
    },
  },
};
</script>

<template>
  <div class="p-4 text-start">
    <h4 class="fw-bold">Database Management</h4>
    <p class="text-muted mb-4">
      Database tools and maintenance operations for backups, restore workflows,
      and health checks.
    </p>

    <div class="alert alert-info d-flex align-items-start" role="alert">
      <i class="bi bi-info-circle me-2"></i>
      <div>
        This module is wired and permission-aware. Action endpoints can be
        connected next.
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-4">
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <h6 class="fw-semibold mb-2">Backup</h6>
            <p class="text-muted small mb-3">
              Create a fresh database backup snapshot.
            </p>
            <button
              class="btn btn-outline-primary btn-sm"
              :disabled="!canBackup && !canManage"
            >
              <i class="bi bi-cloud-arrow-up me-1"></i>
              Start Backup
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <h6 class="fw-semibold mb-2">Restore</h6>
            <p class="text-muted small mb-3">
              Restore database from a selected backup file.
            </p>
            <button
              class="btn btn-outline-warning btn-sm"
              :disabled="!canRestore && !canManage"
            >
              <i class="bi bi-cloud-arrow-down me-1"></i>
              Start Restore
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <h6 class="fw-semibold mb-2">Health Check</h6>
            <p class="text-muted small mb-3">
              Check service status and storage metrics.
            </p>
            <button
              class="btn btn-outline-success btn-sm"
              :disabled="!canManage"
            >
              <i class="bi bi-activity me-1"></i>
              Run Check
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
